import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { CustomValidators } from 'ng2-validation';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { environment } from 'environments/environment.prod';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Product'

  },
  {
    title: 'Edit product'
  
  }
];

//const password = new FormControl('', Validators.required);
//const confirmPassword = new FormControl('', CustomValidators.equalTo(password));

@Component({
  selector: 'page-product-form-edit',
  templateUrl: './product-form-edit.html',
  styleUrls: ['./product-form-edit.scss']
})


export class PageProductEdit implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  public form: FormGroup;
  selectcustomer: any;
  stateCtrl: FormControl;
  filteredStates: any;
  data: any;
  tp_id:string;
  rows=[];
  linePds=[];
  customerStr: string;
  groupStr:string;
  unitStr: string;
  colorStr: string;
  typeStr: string;
  message:string;
  modelStr:string;
  maxStr:string;
  minStr:string;
  lineStr:string;
  lotsizeStr:string;
  specStr:string;
  partnameStr:string;
  partnoStr:string;
  priceStr:string;
  catalogStr:string;
  //diaglog


  dialogRef: MdDialogRef<ProductEditDialog>;
  selectedOption: string;
  SV:string;
  SV2:string;

 

  types = [
    { value: 'FG', viewValue: 'FG' },
    { value: 'Part', viewValue: 'Part' },
    { value: 'RM', viewValue: 'RM' }
  ];
    catalogs1 = [
    { value: 'Export', viewValue: 'Export' },
    { value: 'Import', viewValue: 'Import' }
   
  ];

  units = [
    { value: 'Pcs', viewValue: 'Pcs' },
    { value: 'Kg', viewValue: 'Kg' },
    { value: 'g', viewValue: 'g' },
    { value: 'Cm', viewValue: 'Cm' },
    { value: 'm', viewValue: 'm' },
    { value: 'mm', viewValue: 'mm' },
    { value: 'Can', viewValue: 'Can' },
    { value: 'Box', viewValue: 'Box' },
    { value: 'Roll', viewValue: 'Roll' }
  ];

  colors = [
    { value: 'N/A', viewValue: 'N/A' },
    { value: 'RED', viewValue: 'RED' },
    { value: 'BLACK', viewValue: 'BLACK' },
    { value: 'BLUE', viewValue: 'BLUE' }
  ];

 

  customers = [];
  catalogs =[];
  groups=[];

    //upload file
    imageSrc:any;
    urlApi=environment.url+"/api/uploadToserver.php";
    //uploader:any;
    Name:string; 
    myFile:File; /* property of File type */
    //end upload file

  constructor(private activatedRoute: ActivatedRoute,public dialog: MdDialog,private fb: FormBuilder, private _sharedService: SharedService,private router: Router) {
    this._sharedService.emitChange(this.pageTitle);
     
  }
  getGroup(group){
    this.groupStr = group;
  }
  
    openDialog() {

    
    let dialogRef = this.dialog.open(ProductEditDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.postString();
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }

  filterStates(val: string) {
    return val ? this.customers.filter((s) => new RegExp(val, 'gi').test(s)) : this.customers['tc_company_shortname'];
  }

  onChange(type: string) {
    alert(type);
  }

fetch(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_product.php?id='+this.tp_id);

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  fetchCatalog(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_product_catalog.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }
  fetchGroup(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_tb28_pricess_in4.php?');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  fetchcustomer(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_customer.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  postString() {

    if(this.myFile!=null){
  
    this.data = "group="+this.groupStr+"&line="+this.lineStr+"&filename="+this.myFile.name+"&tp_id="+this.tp_id+"&catalog="+this.catalogStr+"&lotsize="+this.form.controls.lotsize.value+"&customer="+this.customerStr+"&unit=" + this.unitStr + "&color=" + this.colorStr + "&model=" + this.form.controls.model.value + "&partname=" + this.form.controls.partname.value + "&partno=" + this.form.controls.partno.value + "&max=" + this.form.controls.max.value + "&min=" + this.form.controls.min.value + "&spec=" + this.form.controls.spec.value + "&price=" + this.form.controls.price.value + "&type=" + this.typeStr;
    }else{
      this.data = "group="+this.groupStr+"&line="+this.lineStr+"&tp_id="+this.tp_id+"&catalog="+this.catalogStr+"&lotsize="+this.form.controls.lotsize.value+"&customer="+this.customerStr+"&unit=" + this.unitStr + "&color=" + this.colorStr + "&model=" + this.form.controls.model.value + "&partname=" + this.form.controls.partname.value + "&partno=" + this.form.controls.partno.value + "&max=" + this.form.controls.max.value + "&min=" + this.form.controls.min.value + "&spec=" + this.form.controls.spec.value + "&price=" + this.form.controls.price.value + "&type=" + this.typeStr;
    }
    const req = new XMLHttpRequest();
    req.open('POST',  environment.url+'/api/editProduct.php', true);

    //Send the proper header information along with the request
    req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    req.onreadystatechange = function () {//Call a function when the state changes.
      if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
        // Request finished. Do processing here.
        req.onload = () => {
          console.log(JSON.parse(req.response));
          //JSON.parse(req.response);
        };
      }
    }
    req.send(this.data);
    console.log('----data-----', this.data);

  //upload image
  if(this.myFile!=null){
    this.uploadPhoto(this.myFile);
  }
  this.router.navigateByUrl('default-layout/product');

  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }
   
  uploadPhoto(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi}`);
    request.send(formData);
  }

  getCustomer(customer) {
    this.customerStr = customer;
  }
  getUnit(unit) {
    this.unitStr = unit;
  }
  getColor(color) {
    this.colorStr = color;
  }
  getType(type) {
    this.typeStr = type;
  }
  getCatalog(catalog){
    this.catalogStr = catalog;

  }
  getProductionLine(linePd:string){
    //alert(linePd);
     this.lineStr = linePd;
   }
   

   fetchLine(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_line.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }
  ngOnInit() {

this.activatedRoute.params.subscribe((params: Params) => {
        this.tp_id = params['id'];
        console.log('--id--',this.tp_id);
      });
  
      this.fetchCatalog((dataCatalog)=>{
          this.catalogs = dataCatalog;
      });
      this.fetchGroup((dataGroup)=>{
        this.groups = dataGroup;
    });
      this.fetchLine((linePd) => {
        this.linePds = linePd;
      });
      
       this.fetch((data) => {
      // cache our list
     
      //this.model=data[0]['tp_productname'];
      // push our inital complete list

      console.log('------data------',data);
      this.rows = data;
      this.customerStr = this.rows[0].tp_customer;
      this.typeStr = this.rows[0].tp_type;
      this.partnameStr = this.rows[0].tp_part_name;
      this.partnoStr = this.rows[0].tp_part_no;
      this.colorStr = this.rows[0].tp_color;
      this.maxStr = this.rows[0].tp_max_stock;
      this.minStr = this.rows[0].tp_min_stock;
      this.modelStr = this.rows[0].tp_productname;
      this.priceStr = this.rows[0].tp_price;
      this.specStr = this.rows[0].tp_spec;
      this.lotsizeStr = this.rows[0].tp_lotsize;
      this.unitStr = this.rows[0].tp_unit;
      this.colorStr = this.rows[0].tp_color;
      this.catalogStr = this.rows[0].tb5_catproduct_tcp_id;
      this.lineStr = this.rows[0].tp_line;
      this.groupStr = this.rows[0].tb28_process_in4_tpc4_id	
      


      
    });

    this.fetchcustomer((customer) => {
      //this.customers = customer.map(function (val) {
      //  return [val.tc_company_shortname]
      //});
      this.customers = customer;
      console.log('------this.model------', this.customers);
    });


    this.stateCtrl = new FormControl();
    this.filteredStates = this.stateCtrl.valueChanges
      .startWith(null)
      .map(name => this.filterStates(name));


    this.form = this.fb.group({


      //stateCtrl: [null, Validators.compose([Validators.required])],
      model: [null, Validators.compose([Validators.required])],
      partname: [null, Validators.compose([Validators.required])],
      partno: [null, Validators.compose([Validators.required])],
      max: [null, Validators.compose([Validators.required])],
      min: [null, Validators.compose([Validators.required])],
      type: [null, Validators.compose([Validators.required])],
      spec: [null, Validators.compose([Validators.required])],
      price: [null, Validators.compose([Validators.required])],
      lotsize: [null, Validators.compose([Validators.required])]
      //color: [null, Validators.compose([Validators.required])],
      // unit: [null, Validators.compose([Validators.required])]
      //email: [null, Validators.compose([Validators.required, CustomValidators.email])],
      //range: [null, Validators.compose([Validators.required, CustomValidators.range([5, 9])])],
      //url: [null, Validators.compose([Validators.required, CustomValidators.url])],
      //date: [null, Validators.compose([Validators.required, CustomValidators.date])],
      //creditCard: [null, Validators.compose([Validators.required, CustomValidators.creditCard])],
      //phone: [null, Validators.compose([Validators.required, CustomValidators.phone('en-US')])],
      //gender: [null, Validators.required],
      //password: password,
      //confirmPassword: confirmPassword
      

    });



  }
}

//dialog
@Component({
  selector: 'product-dialog',
  templateUrl: 'product-dialog.html',
})
export class ProductEditDialog {
  jazzMessage = 'Jazzy jazz jazz';
  constructor(public dialogRef: MdDialogRef<ProductEditDialog>) {}
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/product/product-form-edit.ts